import Formatic from 'formatic';
import React from 'react';
import _ from 'lodash';
import bemify from 'bemify-js';
import createReactClass from 'create-react-class'; // eslint-disable-line no-restricted-syntax

import Button from 'app/common/components/Button';
import 'app/beta-editor/components/formatic/AddSearch.scss';

const AddSearchButton = createReactClass({
  displayName: 'AddSearchButton',
  mixins: [Formatic.availableMixins.helper],

  onAddSearch() {
    this.props.onAction({
      action: 'add-search',
      field: this.props.field,
    });
  },

  render() {
    return (
      <Button
        className="flowform__pretty-button"
        kind="block"
        onClick={this.onAddSearch}
      >
        Add a Search Step
      </Button>
    );
  },
});

const AddSearch = createReactClass({
  displayName: 'AddSearch',

  getInitialState() {
    return {
      isEnteringCustomValue: false,
    };
  },

  render() {
    const bem = bemify('add-search');
    const selectProps = _.extend({}, this.props);
    selectProps.classes = _.extend({}, selectProps.classes, {
      'add-search': true,
    });

    const origOnAction = selectProps.onAction;
    selectProps.onAction = params => {
      if (params.action === 'enter-custom-value') {
        this.setState({ isEnteringCustomValue: true });
      } else if (params.action === 'exit-custom-value') {
        this.setState({ isEnteringCustomValue: false });
      }
      origOnAction(params);
    };

    const selectControl = this.props.createSelect(selectProps);
    const hasAddSearch =
      !this.state.isEnteringCustomValue && !this.props.field.value;

    if (hasAddSearch) {
      return (
        <div className={bem()}>
          <div className={bem('__button-cell')}>
            <AddSearchButton
              field={this.props.field}
              onAction={this.props.onAction}
            />
          </div>
          <div className={bem('__or-cell')}>or</div>
          <div className={bem('__dropdown-cell')} key="abc">
            {selectControl}
          </div>
        </div>
      );
    }

    return (
      <div>
        <div />
        <div />
        <div key="abc">{selectControl}</div>
      </div>
    );
  },
});

export default AddSearch;
